import API from '@/services/api.js'

const actions = {
  //- Sets the professions
  setProfessions({commit}, professions) {
    console.log('Store - setProfessions')
    //- Mutate store
    commit('SET_PROFESSIONS', professions)
  },
  setSearchableProfessions({ commit }) {
    console.log('Store - setSearchableProfessions')
    API.listProfessions({ isSearchableProfession: true })
      .then(({ data }) => 
        //- Mutate store
        commit('SET_SEARCHABLE_PROFESSIONS', data)
      )
  },
  //- Sets the Employment Types
  setEmploymentTypes({commit}, EmploymentTypes) {
    console.log('Store - setEmploymentTypes')
    //- Mutate store
    commit('SET_EMPLOYMENT_TYPES', EmploymentTypes)
  },
  //- Sets the Application States
  setApplicationStates({commit}, ApplicationStates) {
    console.log('Store - setStates')
    //- Mutate store
    commit('SET_APPLICATION_STATES', ApplicationStates)
  },
  //- Sets the Regions
  setRegions({commit}, Regions) {
    console.log('Store - setRegions')
    //- Mutate store
    commit('SET_REGIONS', Regions)
  },
  setMachines({commit}, Machines) {
    console.log('Store - setMachines')
    //- Mutate store
    commit('SET_MACHINES', Machines)
  },
  //- Sets the DistanceOrder States
  setDistanceOrderStates({commit}, DistanceOrderStates) {
    console.log('Store - setDistanceOrderStates')
    //- Mutate store
    commit('SET_DISTANCEORDER_STATES', DistanceOrderStates)
  },
  setExtensionOrderStates({commit}, extensionOrderStates) {
    console.log('Store - setExtensionOrderStates')
    //- Mutate store
    commit('SET_EXTENSIONORDER_STATES', extensionOrderStates)
  },
  setPrintOrderStates({commit}, PrintOrderStates) {
    console.log('Store - setPrintOrderStates')
    //- Mutate store
    commit('SET_PRINTORDER_STATES', PrintOrderStates)
  },

  //- Sets the systemSettings
  setSystemSettings({commit}, settings) {
    console.log('Store - setSystemSettings')
    //- Mutate store
    commit('SET_SYSTEMSETTINGS', settings)
  },
  updateSystemSettings({commit}, settings) {
    console.log('Store - updateSystemSettings')
    //- Mutate store
    commit('UPDATE_SYSTEMSETTINGS', settings)
  },

  async loadBasics({dispatch}) {
    console.log('Store - loadBasics')
    API.getSystemSettings()
      .then(response => {
        return dispatch('setSystemSettings', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching system settings:', error)
      })

    API.listProfessions()
      .then(response => {
        return dispatch('setProfessions', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching professions:', error)
      })

    API.listEmploymentTypes()
      .then(response => {
        return dispatch('setEmploymentTypes', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching EmploymentTypes:', error)
      })

    await API.listApplicationStates()
      .then(response => {
        return  dispatch('setApplicationStates', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listApplicationStates', error)
      })

    API.listRegions()
      .then(response => {
        return dispatch('setRegions', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listRegions', error)
      })
    API.listMachines()
      .then(response => {
        return dispatch('setMachines', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listRegions', error)
      })

    API.listDistanceOrderStates()
      .then(response => {
        return dispatch('setDistanceOrderStates', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listDistanceOrderStates', error)
      })
    API.listExtensionOrderStates()
      .then(response => {
        return dispatch('setExtensionOrderStates', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listExtensionOrderStates', error)
      })
    API.getPrintOrdersStateList()
      .then(response => {
        return dispatch('setPrintOrderStates', response.data)
      })
      .catch(error => {
        console.log('There was an error fetching listDistanceOrderStates', error)
      })
  }
}

export default actions
